var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 41,
    viewBox: "0 0 150 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.89551,
    cy: 2,
    r: 2,
    fill: "currentColor",
    fillOpacity: 0.22
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.3164,
    cy: 2,
    r: 2,
    fill: "currentColor",
    fillOpacity: 0.22
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.7373,
    cy: 2,
    r: 2,
    fill: "currentColor",
    fillOpacity: 0.22
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.1582,
    cy: 2,
    r: 2,
    fill: "currentColor",
    fillOpacity: 0.22
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.579,
    cy: 2,
    r: 2,
    fill: "currentColor",
    fillOpacity: 0.22
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 2,
    r: 2,
    fill: "currentColor",
    fillOpacity: 0.22
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.3164,
    cy: 30,
    r: 2,
    fill: "currentColor",
    fillOpacity: 0.22
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.7373,
    cy: 30,
    r: 2,
    fill: "currentColor",
    fillOpacity: 0.22
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.1582,
    cy: 30,
    r: 2,
    fill: "currentColor",
    fillOpacity: 0.22
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.579,
    cy: 30,
    r: 2,
    fill: "currentColor",
    fillOpacity: 0.22
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 30,
    r: 2,
    fill: "currentColor",
    fillOpacity: 0.22
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.374b8b82.svg";
export { ForwardRef as ReactComponent };